import React from "react";
import { useTranslation } from "react-i18next";
import "./About.css";

const AboutCard = () => {
  const { t } = useTranslation();

  return (
    <div className="aboutCard mtop flex_space aboutCardInfo">
      <div className="row row1">
        <h4>{t("aboutUs")}</h4>
        <div className="aboutContent">
          <div>{t("aboutHeading")}</div>
          <div>{t("aboutLocation")}</div>
          <div>{t("aboutText")}</div>
        </div>
      </div>
      <div>
        <img
          src="/images/myimages/222.jpg"
          alt="sharaimg"
          width="600px"
          height="500px"
          className="cardimage"
        />
      </div>
    </div>
  );
};

export default AboutCard;
